<div class="container" dir="rtl">
  <div *ngIf="report?.FuelEfficiencyScore">
    <ng-container *ngIf="report?.FuelEfficiencyScore !== -1">
      <div class="report-card">
        <p class="report-text text-center">{{report?.ProblemCategory}}</p>
        <div class="score-section py-4">
          <div class="score-number">
            <small>100 /</small>
            {{ report?.FuelEfficiencyScore }}
          </div>

          <div class="progress-track">
            <div class="progress-fill" [style.width.%]="report?.FuelEfficiencyScore"></div>
          </div>

          <div class="text-center pt-4">
            <span
              class="status-badge"
              [ngClass]="{
                'good': report?.FuelEfficiencyScore >= 70,
                'medium': report?.FuelEfficiencyScore >= 40 && report?.FuelEfficiencyScore < 70,
                'bad': report?.FuelEfficiencyScore < 40
                }">
              {{ report?.EfficiencyLevel }}
            </span>
          </div>
        </div>

        <div class="report-section">
          <h3>گزارش تحلیل</h3>
          <div class="report-text">
            {{ report?.DiagnosticReport }}
          </div>
        </div>
      </div>
    </ng-container>
  </div>
</div>
